module.exports = __webpack_public_path__ + "img/71.8975ed04.webp";